import React from 'react';
import { GeneralContext } from '../../context/generalContext';

export default function DeliveryBtn({ isMobile }) {
  const { subdomain, activeLanguage, setActiveMenuItem } = React.useContext(GeneralContext);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
    });
    setActiveMenuItem();
  };
  const excludedSubdomains = ['18', '19', '10', 'vrn', 'alt', 'nsk', 'nkz', 'test'];

  return (
    <>
      {!excludedSubdomains.includes(subdomain) &&
        window.location.hostname.split('.')[window.location.hostname.split('.').length - 1] !== 'uz' && (
          <a
            href='https://delivery.lambic.ru/'
            className={
              isMobile
                ? 'footer-fixed-btn-mobile footer-fixed-btn-mobile--delivery'
                : 'footer-fixed-btn footer-fixed-btn--delivery'
            }
            onClick={goToTop}
            target='_blank'
            rel='noreferrer'
          >
            <p className={isMobile ? 'footer-fixed-btn-mobile--text-gold' : ''}>
              {activeLanguage === 1 ? 'Доставка' : 'Delivery'}
            </p>
          </a>
        )}

      {subdomain === '10' && (
        <a
          href='https://eda.yandex.ru/moscow/r/brasserie_lambic_dohyb?placeSlug=brasserie_lambic_cherkass'
          className={
            isMobile
              ? 'footer-fixed-btn-mobile footer-fixed-btn-mobile--delivery'
              : 'footer-fixed-btn footer-fixed-btn--delivery'
          }
          onClick={goToTop}
          target='_blank'
          rel='noreferrer'
        >
          <p className={isMobile ? 'footer-fixed-btn-mobile--text-gold' : ''}>
            {activeLanguage === 1 ? 'Доставка' : 'Delivery'}
          </p>
        </a>
      )}

      {subdomain === '18' && (
        <a
          href='https://eda.yandex.ru/moscow/r/brasserie_lambic_dohyb?placeSlug=brasserie_lambic_mtjvc'
          className={
            isMobile
              ? 'footer-fixed-btn-mobile footer-fixed-btn-mobile--delivery'
              : 'footer-fixed-btn footer-fixed-btn--delivery'
          }
          onClick={goToTop}
          target='_blank'
          rel='noreferrer'
        >
          <p className={isMobile ? 'footer-fixed-btn-mobile--text-gold' : ''}>
            {activeLanguage === 1 ? 'Доставка' : 'Delivery'}
          </p>
        </a>
      )}

      {subdomain === '19' && (
        <a
          href='https://eda.yandex.ru/moscow/r/brasserie_lambic_dohyb?placeSlug=brasserie_lambic_sebdj'
          className={
            isMobile
              ? 'footer-fixed-btn-mobile footer-fixed-btn-mobile--delivery'
              : 'footer-fixed-btn footer-fixed-btn--delivery'
          }
          onClick={goToTop}
          target='_blank'
          rel='noreferrer'
        >
          <p className={isMobile ? 'footer-fixed-btn-mobile--text-gold' : ''}>
            {activeLanguage === 1 ? 'Доставка' : 'Delivery'}
          </p>
        </a>
      )}

      {subdomain === 'nsk' && (
        <a
          href='/delivery'
          className={
            isMobile
              ? 'footer-fixed-btn-mobile footer-fixed-btn-mobile--delivery'
              : 'footer-fixed-btn footer-fixed-btn--delivery'
          }
          onClick={goToTop}
          target='_blank'
          rel='noreferrer'
        >
          <p className={isMobile ? 'footer-fixed-btn-mobile--text-gold' : ''}>
            {activeLanguage === 1 ? 'Самовывоз' : 'Pickup'}
          </p>
        </a>
      )}
    </>
  );
}
